import http from '../plugins/axios'

export const getAllCurrencyList = async (params) => {
  try {
    const response = await http.get(`/api/v2/currencies`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createCurrency = async (data) => {
  try {
    const response = await http.post(`/api/v2/currencies`, data)
    return response.data
  } catch (error) {
    throw error
  }

}

export const updateCurrency = async (id, data) => {
  try {
    const response = await http.put(`/api/v2/currencies/${id}`, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteCurrency = async (id) => {
  try {
    const response = await http.delete(`/api/v2/currencies/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}